import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { store } from '../../store'
import * as UI from '../../lib/ui'
import fallbackLogo from '../../assets/img/PBSNational.webp'
import tts from '../../lib/TTS'
import { platformStoreSet } from '../../../../shared/helpers'
import googleAnalytics4 from '../../lib/googleAnalytics'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

export class SplashScreen extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: false,
    }
  }

  getDeeplinkState = (state) => {
    return state.deeplink
  }

  componentDidMount() {
    UI.setSidePanelVisibility(false)
    platformStoreSet('sawSplashScreen', 'true')

    this.props.shortCommonName === undefined
      ? tts.addTextToRead(`PBS`)
      : tts.addTextToRead(`${this.props.shortCommonName}`)

    googleAnalytics4.sendPageViewEvent('Splash Screen')

    /* window.ga('send', 'pageview', 'Splash') */
    if (COMPILING_FOR_COMCASTX1 && COMCAST_IN_APP_DONATIONS_ENABLED) {
      this.getDonationQueryParams()
    }

    setTimeout(() => {
      let targetUrl = ''

      if (this.props.pid || this.props.UID) {
        if ('' !== this.props.deeplinkUrl) {
          targetUrl = this.props.deeplinkUrl
        } else {
          targetUrl = '/home'
        }
      } else {
        targetUrl = '/activate'
        if ('' !== this.props.deeplinkUrl) {
          targetUrl += `?redirect=${encodeURIComponent(this.props.deeplinkUrl)}`
        }
      }

      this.setState({
        done: true,
      })
      //Reset the deeplink url so we don't keep going to the same page if we ever find ourselves back on the Splash screen.
      store.dispatch({
        type: 'DEEPLINK_URL',
        payload: {
          url: '',
          message: `deeplink reset`,
          sawSplash: true,
        },
      })
      this.props.router.navigate(targetUrl)
    }, 3000)
  }

  getDonationQueryParams = () => {
    const donationParams = this.props.router.location.search
    store.dispatch({
      type: 'UPDATE_DONATION_QUERY_PARAMS',
      payload: donationParams,
    })
  }

  render() {
    const stationLogo = this.props.stationLogo || fallbackLogo
    return (
      <div className="splash-screen-container">
        {/* after successful localization cobrand or national logo ELSE explicitly use fallback */}
        {stationLogo ? (
          <img
            className="splash-img"
            src={stationLogo}
            alt="PBS Logo"
            style={{ maxHeight: '190px', maxWidth: '1500px' }}
          />
        ) : null}
      </div>
    )
  }
}

SplashScreen.propTypes = {
  callSign: PropTypes.string,
  UID: PropTypes.string,
  router: PropTypes.shape({
    navigate: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
  }),
  shortCommonName: PropTypes.string,
  station_id: PropTypes.string,
  stationLogo: PropTypes.string,
  pid: PropTypes.string,
  deeplinkUrl: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    UID: state.device.UID,
    callSign: state.station.call_sign,
    shortCommonName: state.station.short_common_name,
    deviceModel: state.device.deviceModel,
    station_id: state.station.station_id,
    stationLogo: state.station.white_cobranded_logo,
    pid: state.user.pid,
    deeplinkUrl: state.deeplink.url,
  }
}

export default connect(mapStateToProps, null, null)(withRouter(SplashScreen))
